import { createContext, useContext, useMemo, useState } from "react";

const ModalContext = createContext(null);

export const ModalProvider = ({ children }) => {
  const [modal, setModal] = useState({ open: false, title: "Notice", message: "" });

  const showModal = (message, title = "Notice") => {
    setModal({ open: true, title, message });
  };

  const closeModal = () => {
    setModal((current) => ({ ...current, open: false }));
  };

  const value = useMemo(() => ({ showModal, closeModal }), []);

  return (
    <ModalContext.Provider value={value}>
      {children}
      {modal.open ? (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 px-4">
          <div className="w-full max-w-lg rounded-lg bg-white p-6 shadow-xl">
            <h3 className="mb-3 text-xl font-semibold text-gray-800">{modal.title}</h3>
            <p className="mb-5 text-gray-700 leading-relaxed">{modal.message}</p>
            <div className="text-right">
              <button onClick={closeModal} className="rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-700">
                OK
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </ModalContext.Provider>
  );
};

export const useModal = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error("useModal must be used inside ModalProvider");
  }
  return context;
};
